module.exports = __webpack_public_path__ + "img/13.52e480ad.png";